module.exports = __webpack_public_path__ + "img/pinpng.com-csgo-logo-png-235434.9184c04b.png";